//Set the height of the header as a custom property that can be used by sticky objects.
window.addEventListener('scroll', function(){
    var header = document.querySelector("header.sticky-top");
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + "px");
});

var anchor = function() {
    var transformKeys = ['mstransform', 'webkittransform', 'moztransform', 'otransform', 'transform' ];
    return {
        attach: function(selector) {
            var type = typeof selector;
            if (type === 'string') {
                var nodes = document.querySelectorAll(selector);
                for(var i = 0; i < nodes.length; i++) {
                    anchorElement(nodes[i]);
                }
            } else if (type === 'object') {
                anchorElement(selector);
            }
        }
    };

    function anchorElement(node) {
        var directParent = node.parentNode;
        var scrollParent = getScrollParent(node);

        if (scrollParent != null) {
            scrollParent.parentNode.addEventListener('scroll', function(e) {
                var targetTop = scrollParent.scrollTop;
                var targetBottom = targetTop + node.offsetHeight;
                var maxBottom = directParent.offsetHeight;

                if (targetBottom > maxBottom) {
                    targetTop = maxBottom - node.offsetHeight;
                }

                var translate = 'translate(0, ' + targetTop + 'px)';
                for(var i = 0; i < transformKeys.length; i++) {
                    node.style[transformKeys[i]] = translate;
                }
            });
        }       
    }

    function getScrollParent(node) {
        if (node == null) {
            return null;
        }
        
        if (node.scrollHeight > node.clientHeight) {
            return node;
        } else {
            return getScrollParent(node.parentNode);
        }
    }
}(); 